const NewsCardSkeleton = () => (
  <div className="animate-pulse gap-x-6 gap-y-8 py-8 grid-sublayout-default grid-sublayout md:items-center lg:py-16">
    <div className="col-span-4 aspect-video bg-gray-400 lg:col-span-5" />
    <div className="col-span-4 grid grid-cols-4 md:col-span-3 md:col-start-6 lg:col-span-4 lg:col-start-7">
      <div className="col-span-2 h-[1em] rounded bg-gray-300 text-body-xs" />
      <div className="col-span-4 mt-7 h-[3em] rounded bg-gray-300 text-headline-md md:col-span-3 md:mt-4 lg:col-span-4" />
    </div>
  </div>
)

export default NewsCardSkeleton
